import React from 'react'
import { Link } from 'react-router'

const Services = () => {
  return (
    <>
         <section className="services pt-170 pb-150">
            <div className="container pos-rel">
                <div className="servics-title-box ul_li_between align-items-end mb-35">
                    <div className="section-title mb-30">
                        <span className="sub-title wow fadeInRight" data-wow-duration=".7s">Core Services</span>
                        <h3 className="title xb-split-text split-in-right">Discover Our <br/> <span>Capabilities</span></h3>
                    </div>
                    <div className="service-logo mb-30">
                        <img src="assets/img/About/ab_logo.png" alt=""/>
                    </div>
                </div>
               
                <div className="row mt-none-30">
                    <div className="col-lg-6 mt-30">
                        <div className="xb-service-box">
                            <div className="xb-item--inner ul_li">
                                <div className="xb-item--icon">
                                    <img src="assets/img/icon/srv_01.svg" alt=""/>
                                </div>
                                <div className="xb-item--holder">
                                    <h3 className="xb-item--title">Website Design</h3>
                                    <p className="xb-item--content">Custom website design services by Om Softwares to create responsive, user-friendly, and SEO-optimized websites for your business.</p>
                                </div>
                                <span className="xb-item--shape">
                                    <img src="assets/img/icon/srv_shape.png" alt=""/>
                                </span>
                                <Link className="xb-overlay" to="/web-development"></Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 mt-30">
                        <div className="xb-service-box">
                            <div className="xb-item--inner ul_li">
                                <div className="xb-item--icon">
                                    <img src="assets/img/icon/srv_02.svg" alt=""/>
                                </div>
                                <div className="xb-item--holder">
                                    <h3 className="xb-item--title">Software Design</h3>
                                    <p className="xb-item--content">Innovative software design solutions from Om Softwares to streamline your business operations with intuitive, high-performance applications.</p>
                                </div>
                                <span className="xb-item--shape">
                                    <img src="assets/img/icon/srv_shape.png" alt=""/>
                                </span>
                                <Link className="xb-overlay" to="/services"></Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 mt-30">
                        <div className="xb-service-box">
                            <div className="xb-item--inner ul_li">
                                <div className="xb-item--icon">
                                    <img src="assets/img/icon/srv_03.svg" alt=""/>
                                </div>
                                <div className="xb-item--holder">
                                    <h3 className="xb-item--title">Visual Branding</h3>
                                    <p className="xb-item--content">Om Softwares offers creative graphic design services to help your brand stand out with visually appealing and impactful designs.</p>
                                </div>
                                <span className="xb-item--shape">
                                    <img src="assets/img/icon/srv_shape.png" alt=""/>
                                </span>
                                <Link className="xb-overlay" to="/visual-branding"></Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 mt-30">
                        <div className="xb-service-box">
                            <div className="xb-item--inner ul_li">
                                <div className="xb-item--icon">
                                    <img src="assets/img/icon/srv_04.svg" alt=""/>
                                </div>
                                <div className="xb-item--holder">
                                    <h3 className="xb-item--title">Mobile App Design</h3>
                                    <p className="xb-item--content">Transform your business with custom mobile app designs by Om Softwares, delivering seamless user experiences on all devices.</p>
                                </div>
                                <span className="xb-item--shape">
                                    <img src="assets/img/icon/srv_shape.png" alt=""/>
                                </span>
                                <Link className="xb-overlay" to="/services"></Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 mt-30">
                        <div className="xb-service-box">
                            <div className="xb-item--inner ul_li">
                                <div className="xb-item--icon">
                                    <img src="assets/img/icon/srv_05.svg" alt=""/>
                                </div>
                                <div className="xb-item--holder">
                                    <h3 className="xb-item--title">Digital Marketing</h3>
                                    <p className="xb-item--content">Boost your online presence with Om Softwares' digital marketing services, including SEO, social media, and PPC strategies for maximum visibility.</p>
                                </div>
                                <span className="xb-item--shape">
                                    <img src="assets/img/icon/srv_shape.png" alt=""/>
                                </span>
                                <Link className="xb-overlay" to="/digital-marketing"></Link>
                                
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 mt-30">
                        <div className="xb-service-box">
                            <div className="xb-item--inner ul_li">
                                <div className="xb-item--icon">
                                    <img src="assets/img/icon/srv_06.svg" alt=""/>
                                </div>
                                <div className="xb-item--holder">
                                    <h3 className="xb-item--title">UI/UX Design</h3>
                                    <p className="xb-item--content">Enhance user engagement with Om Softwares' expert UI/UX design services, crafting intuitive and aesthetically pleasing interfaces for web and mobile apps.</p>
                                </div>
                                <span className="xb-item--shape">
                                    <img src="assets/img/icon/srv_shape.png" alt=""/>
                                </span>
                                <Link className="xb-overlay" to="/services"></Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="service-shape xb-blur"></div>
            </div>
        </section>
        
    </>
  )
}

export default Services
